import { render, staticRenderFns } from "./VueScrollFixedNavbar.vue?vue&type=template&id=f6abe230&"
import script from "./VueScrollFixedNavbar.vue?vue&type=script&lang=js&"
export * from "./VueScrollFixedNavbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports